<template>
  <draggable
    class="folders__container"
    tag="ul"
    :list="folders"
    :group="{ name: 'g1', pull: 'clone',  }"
    item-key="name"
  >
    <template #item="{ element }">
    	<div class="folders__item">
    		<div class="folder__header"><p>{{element.title}}</p><p class="folder__add">+</p></div>
				<div class="folder__content">
					<img class="folder__img" :src="element.preview">
				</div>
			</div>
    </template>
  </draggable>
</template>
<script>
import draggable from "vuedraggable";
import { markRaw } from 'vue'

export default {
  props: {
    folders: {
      required: true,
      type: Array
    }
  },
  components: {
    draggable: markRaw(draggable),
  },
  name: "nested-draggable"
};
</script>
<style scoped>
.folder__add {
	transition: 0.5s ease all;
}
.folder__header {
  padding: 0.5rem;
	background-color: var(--color-bg);
  border-radius: 0.4rem 0.4rem 0 0;
  display: flex;
  font-weight: bold;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
	align-items: center;
  p {
    text-align: left;
  }
}
.folder__header:hover .folder__add {
	transform: rotate(180deg)
}
.folders__item {
	background-color: var(--grey-1);
	overflow: hidden;
  border-radius: 0.5rem;
}
.folder__content {
	padding: 0rem;
}
.folder__img {
  width: 100%;
  height: 12vw;
  max-height: 150px;
}
</style>